import React from 'react'
import { Typography, Box } from '@material-ui/core'
import SearchDisplayFilteringInfo from '../../atoms/SearchDisplayFilteringInfo'
import PapersTable from '../../molecules/PapersTable'
import { useCprmSearch } from '../../pages/Search/hooks'

const Component: React.FC = () => {
  const { papers, freewords, filterTagsV2, excludeTagsV2, selectHeatMapCellTags, heatMapFilterdPapers, handleReset } =
    useCprmSearch()

  return (
    <>
      <Typography variant="h2">Pickup Table</Typography>
      <Typography variant="body2" gutterBottom>
        {/* eslint-disable-next-line react/jsx-curly-brace-presence */}
        {
          'View the paper list here. Sort tags in ascending/descending order by clicking the arrow. Click titles to view paper details.'
        }
      </Typography>
      <Box paddingTop={1}>
        <SearchDisplayFilteringInfo
          papers={papers}
          filteringPapers={heatMapFilterdPapers}
          freewords={freewords}
          filterTagsV2={filterTagsV2}
          excludeTagsV2={excludeTagsV2}
          selectHeatMapCellTags={selectHeatMapCellTags}
          enableAddPaperInfo
          handleReset={handleReset}
        />
      </Box>
      <PapersTable papers={heatMapFilterdPapers} />
    </>
  )
}

export default Component
